<template>
    <section class="blockElement loginLoader-page">
         <loader :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></loader>
        <!-- <app-language> </app-language>   -->
        <div class="container-fluid">
            <div class="innerInclude">
                <div class="row w-100">
                    <div class="col-12 col-md-4  text-center d-flex vh_100 flex-wrap blueBG beforeBG justify-content-center align-items-center">
                        <div class="titleArera Loginlogo">
                           <img src="../../../../static/fxView/images/logo-white.svg" alt="fxView">
                        </div>
                        <!-- <div class="PortfoliosTitle"> 
                            <div id="demo" class="carousel slide fxRegisterSteps " data-ride="carousel"> 
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                       
                                        <img src="../../../../static/fxView/images/login_trading_platform.svg" alt="Banner">
                                        <h3>{{$t('lg_welcomeMsgHeadone')}}</h3>
                                        <p>{{$t('lg_welcomeMsg1')}}</p>       
                                    </div>
                                    <div class="carousel-item">
                                        <img src="../../../../static/fxView/images/login_trader_toolbox.svg" alt="Banner">
                                        <h3>{{$t('lg_welcomeMsgHeadtwo')}}</h3>
                                        <p>{{$t('lg_welcomeMsg2')}}</p>
                                    </div>
                                    <div class="carousel-item">
                                        <img src="../../../../static/fxView/images/login_download_platform.svg" alt="Banner">
                                        <h3>{{$t('lg_welcomeMsgHeadthree')}}</h3>
                                        <p>{{$t('lg_welcomeMsg3')}}</p>
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                                <ul class="carousel-indicators mt-5">
                                    <li data-target="#demo" data-slide-to="0" class="active"></li>
                                    <li data-target="#demo" data-slide-to="1"></li>
                                    <li data-target="#demo" data-slide-to="2"></li>
                                </ul>
                            </div>
                        </div> --> 
                        <div class="loginNewSection  ">
                            <div class="loginSpreads d-flex">
                                <div class="d-flex position-relative InnerLogin">
                                    <div class="loginIcon">
                                        <figure>
                                            <img src="../../../../static/fxView/images/Spreads.png" alt="">  
                                        </figure>                                     
                                    </div>
                                    <div class="LoginContent  text-left">
                                        <h3>Spreads</h3>
                                        <p>from 0.0 pips</p>
                                    </div>
                                </div>
                            </div>
                            <div class="loginSpreads d-flex ">
                                <div class="d-flex position-relative InnerLogin">
                                    <div class="loginIcon">
                                        <figure>
                                            <img src="../../../../static/fxView/images/Commission.png" alt="">  
                                        </figure>                                     
                                    </div>
                                    <div class="LoginContent text-right">
                                        <h3>$1 per</h3>
                                        <p>$100K Commission</p>
                                    </div>
                                </div>
                            </div>
                            <div class="loginSpreads d-flex">
                                <div class="d-flex position-relative InnerLogin">
                                    <div class="loginIcon">
                                        <figure>
                                            <img src="../../../../static/fxView/images/TradingTools.png" alt="">  
                                        </figure>                                     
                                    </div>
                                    <div class="LoginContent text-left">
                                        
                                        <h3>A variety of </h3>
                                        <p>Trading Tools</p>
                                    </div>
                                </div>
                            </div>
                            <div class="loginSpreads d-flex ">
                                    <div class="d-flex position-relative InnerLogin">
                                    <div class="loginIcon">
                                        <figure>
                                            <img src="../../../../static/fxView/images/FastExecution.png" alt="">  
                                        </figure>                                     
                                    </div>
                                    <div class="LoginContent text-right">
                                        <h3>Ultra</h3>
                                        <p>Fast Execution</p>
                                        
                                    </div>
                                </div>
                            </div>
                            <div class="loginSpreads d-flex">
                                <div class="d-flex position-relative InnerLogin">
                                    <div class="loginIcon">
                                        <figure>
                                            <img src="../../../../static/fxView/images/DepositBonus.png" alt="">  
                                        </figure>                                     
                                    </div>
                                    <div class="LoginContent text-left">
                                        <h3>100%</h3>
                                        <p>Deposit Bonus</p>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--loader - message--->
                   
                    <div class="col-12 col-md-8  d-flex vh_100 align-items-center" v-if="insertId == '-1'">
                        
                        <div class="sign_insec registerPAgeloder">
                            <!-- {{ countriesList }} -->
                            <div class="subtitle">
                                <h3 class="mb-0 mb-md-3 mt-3 mt-md-0">IB Account Registration</h3>
                                 <message :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message>
                                <!-- <p class="mb-3">{{$t('registerMsz1')}}</p> -->
                               
                                
                            </div>
                            <div class="stepForm">
                                <div class="form-group field-wrapper">
                                    <div class="position-relative">
                                        <input placeholder=" " type="text" name="Name" v-model="username" class="float-field form-control" v-validate="'required'"   :class="{ 'is-invalid': submitted && errors.has('fname') }" />
                                        <label for="username" class="float-label">Enter Name</label>
                                    </div>
                                    <p class="error" v-for="error in errors.collect('Name')">{{ error }}</p>
                                </div>
                                <!-- <div class="form-group field-wrapper">
                                    <div class="position-relative">
                                        <input placeholder=" " type="text" name="First Name" v-model="fname" class="float-field form-control" v-validate="'required'"   :class="{ 'is-invalid': submitted && errors.has('fname') }" />
                                        <label for="username" class="float-label">Enter First Name</label>
                                    </div>
                                    <p class="error" v-for="error in errors.collect('First Name')">{{ error }}</p>
                                </div>
                                <div class="form-group field-wrapper">
                                    <div class="position-relative">
                                        <input placeholder=" " type="text" name="Last Name" v-model="lname" class="float-field form-control" />
                                        <label for="username" class="float-label">Enter Last Name</label>
                                    </div>
                                </div> -->
                                <div class="form-group field-wrapper">
                                    <div class="position-relative">
                                        <!-- <input placeholder=" " type="text" name="email" v-model="email" class="float-field form-control" v-validate="'required|email'"   :class="{ 'is-invalid': submitted && errors.has('email') }" ref="emailInput" v-on:keyup="($route.query.refLink)? '' : checkEmail()"/> -->
                                        <input placeholder="" @input="validateEmail" type="email" name="Email" v-model="email" class="float-field form-control" v-validate="'required|email'" :class="{ 'is-invalid': submitted && errors.has('Email')}" ref="emailInput" />
                                        <label for="username" class="float-label">Enter email address</label>
                                    </div>
                                    <span v-if="error" class="error">{{error}}</span>
                                    <!-- <p class="error" v-for="error in errors.collect('Email')">{{ error }}</p> -->
                                </div>
                                <div class="form-group field-wrapper">
                                    <div class="position-relative">
                                        <input placeholder=" " :type="inputtype" name="Password" v-model="password" class="float-field form-control" v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?!.*[\\\/,'~])(?=.*[!@#$%^&*])\S{6,24}$/}">
                                        <label for="username" class="float-label">Enter Your Password</label>
                                        <feather :type="iconType" class="mailTo toggle-password" @click.prevent="switchVisibility('1')"></feather>
                                    </div>
                                     <p class="error" v-for="error in errors.collect('Password')">
                                        <span v-show="error == 'The Password field is required.'">{{$t('reg_passwordFieldReq')}}</span>
                                        <span v-show="error == 'The Password field format is invalid.'">{{$t('reg_passCharVal')}}</span>
                                     </p> 
                                </div>
                                <div class="form-group field-wrapper">
                                    <div class="position-relative">
                                        <input placeholder=" " :type="inputtype1" name="Confirm Password" class="float-field form-control" v-validate="{ required: true, confirmed:password}"  :class="{ 'is-invalid': submitted && errors.has('Confirm Password') }">
                                        <label for="username" class="float-label">Confirm Password</label>
                                        <feather :type="iconType1" class="mailTo toggle-password" @click.prevent="switchVisibility('2')"></feather>
                                    </div>
                                     <p class="error" v-for="error in errors.collect('Confirm Password')">
                                       <span v-show="error == 'The Confirm Password field is required.'">{{$t('reg_ConfpasswordReq')}}</span>
                                         <span v-show="error == 'The Confirm Password confirmation does not match.'">{{$t('reg_newConfFieldSame')}}</span>
                                     </p>
                                </div>
                                <!-- <div class="form-group field-wrapper" v-if="admin_idList.length > 1">
                                    <select name="rm_id" v-model="rm_id" class="float-field form-control" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('rm_id') }" ref="rm_idInput" >
                                        <option v-for="val in admin_idList" :value="val.rm_id">{{val.username}}</option>
                                    </select>
                                    <label for="rm_id" class="float-label">Whom would you like as an RM?</label>
                                    <p class="error" v-for="error in errors.collect('rm_id')">{{ error }}</p>
                                </div>-->
                                <div class="form-group field-wrapper">
                                    <div class="position-relative">
                                        <select class="float-field form-control" onclick="this.setAttribute('value', this.value);" value=""  name ="residence country" v-model="country" v-validate="'required'">
                                            <option :value="null" disabled>Select Country Name</option>
                                            <option :value="list.iso2" v-for="(list,index) in countriesList">{{ list.name }}</option>
                                        </select>
                                        <label for="username" class="float-label">Select Residence Country</label>
                                    </div>
                                    <p class="error" v-for="error in errors.collect('residence country')">{{ error }}</p>
                                </div>
                                <div class="form-group field-wrapper phone-wrapper"> 
                                    <vue-phone-number-input 
                                        v-model="mobile_number"  
                                        :no-example="true" 
                                        :default-country-code="getCountryCode()" 
                                        v-validate="{ required: true, min:5, max:15 }" 
                                        ref="mobile_numberInput" 
                                        class="float-field form-control"
                                        :class="{ 'is-invalid': submitted && errors.has('mobile_number') }" 
                                        name="mobile_number" 
                                        @update="updatedText"
                                    />
                                    <p class="error mb-2" v-if="submitted" v-for="error in errors.collect('mobile_number')">{{$t('InvalidNumber')}}</p>  
                                </div>
                                <!-- <div class="form-group field-wrapper mb-3">
                                    <input placeholder=" " :type="inputtype" name="password" v-model="password" class="float-field form-control" v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])\S{6,24}$/}"   :class="{ 'is-invalid': submitted && errors.has('password') }" ref="passwordInput" > 
                                    <label for="username" class="float-label">{{$t('password')}}</label>
                                    <feather :type="iconType" class="mailTo toggle-password" @click.prevent="switchVisibility"></feather> 
                                    <p class="error textLenth" v-for="error in errors.collect('password')">
                                        <span v-show="error == 'The password field is required.'">{{$t('passwordFieldReq')}}</span>
                                        <span v-show="error == 'The password field format is invalid.'">{{$t('passWordMustContain')}}</span>
                                    </p>
                                    
                                </div>  -->

                                <div class="capticha">
                                    <vue-recaptcha class="captchaRegister"
                                        sitekey="6LfjMUspAAAAAM2jg7TJRN8bg7vOzkJx9aNffYcQ" ref="recaptcha"
                                        @verify="onCaptchaVerified" @expired="onCaptchaExpired"
                                        size="invisible"></vue-recaptcha>
                                    <p class="error">
                                        <span v-if="captachErr">{{ $t("reg_captchaErr") }}</span>
                                    </p>
                                </div>
                                <!-- <div class="form-group field-wrapper phone-wrapper"> 
                                    <vue-phone-number-input 
                                        v-model="mobile_number"  
                                        :no-example="true" 
                                        :default-country-code="getCountryCode()" 
                                        v-validate="{ required: true, min:5, max:15 }" 
                                        ref="mobile_numberInput" 
                                        class="float-field form-control"
                                        :class="{ 'is-invalid': submitted && errors.has('mobile_number') }" 
                                        name="mobile_number" 
                                        @update="updatedText"
                                    />
                                    <p class="error mb-2" v-if="submitted" v-for="error in errors.collect('mobile_number')">{{$t('InvalidNumber')}}</p>  
                                </div>  -->
								<!--<div v-if="showRmTab">
									<div class="form-group selectRM field-wrapper mb-3 d-flex align-items-center justify-content-between" >
										 
                                        <p class="m-0">Are you in touch with in of our rm ?</p>
                                        <div class="rmShowHide">
                                            <a @click.prevent="showRm = true" href="#" class="yes" :class="(showRm == true)? 'active' :''">yes</a>
                                            <a @click.prevent="showRm = false ; searchRm = '' ; searchResult= 'please search rm'" href="#" class="no" :class="(showRm == false)? 'active' :''">no</a>
                                        </div>
                                         
									</div>
									<div  class="form-group field-wrapper" v-if="showRm"> 
                                        <div class="searchInput-result position-relative">
											<input type="text"  v-model="searchRm" name="searchRm" v-on:keyup="keymonitorFunc" class="float-field form-control pt-0" placeholder="Search Here">
											<span class="icon"><feather type="search"></feather></span>
                                        </div>
										<div class="serresult" v-if="typeof(searchResult) == 'object' && searchResult != ''">
											<p v-for="list in searchResult" @click.prevent="rmId = list.id ; searchRm = list.name ; searchResult= ''">{{list.name}}</p>
										</div>
										<div class="serresult" v-if="typeof(searchResult) == 'string' && searchResult != ''">
											{{searchResult}}
										</div>
									</div>
								</div>-->
                                <div class="form-group field-wrapper mb-3">
                                    <p>By Continuing you agree to our<a :href="privacyPolicyLink" target="_blank"> {{$t('reg_privacyPolicy')}}.</a> </p>
                                </div>
                                <div class="clearfix"></div>
                                <div class=" d-flex justify-content-between align-items-center ">
                                    <button class="prism_btn btn_sm mr-md-3" @click.prevent="create_new_lead()">{{$t('register')}}</button>
                                    
                                    <div class="forgot_sec">
                                        <router-link :to="'/'" class="tpArea">Back to login </router-link>
                                    </div>
                                </div>
                                <div class="text-left mt-3 border-top pt-3 customnewcheckbox">
                                    <p class="f-12">Charlgate SVG LLC is a company registered in the St Vincent and the Grenadines with company registration number 1112 LLC 2021.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-7 text-center d-flex vh_100 align-items-center" v-else>
                        <div class="sign_insec registerPAgeloder">
                            <div class="stepForm">
                                <div class="otpBlock">
                                    <img width="80" class=" mb-3" src="../../../../static/fxView/images/mailGrop.svg" />
                                    
                                    <message :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message>
                                    <p class="mb-3"> {{$t('reg_registerMsz2')}} </p>
                                    <div class="form-group field-wrapper">
                                        <div class="position-relative">
                                            <input placeholder=" " type="text" v-model="otp" name="otp" class="float-field form-control" :class="{ 'is-invalid': submittedOtp && errors.has('otp') }" v-validate="{ required: true, max: 6,numeric : true }" ref="otpInput">
                                            <label for="pannumber" class="float-label">{{$t('reg_enterOtp')}} </label>
                                        </div>
                                        <p class="error text-left" v-for="error in errors.collect('otp')">{{ error }}</p>
                                    </div>
                                    <div class="signupbtn submitButton">
                                        <button class="prism_btn btn_sm mb-3" @click.prevent="verify_lead()">{{$t('reg_submit')}} </button>
                                        <div class="forgot_sec otptext">
                                            <a href="#" class="tpArea underline" @click.prevent="resend()">{{$t('reg_resendotp')}} </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                  
            </div>
        </div>
        <!--<div class="fixedBarBottom fullwidth">
            <div class="footPromoLastBar  text-center">
                <p class="" v-html="$t('footerMsz2')"></p>
                <a href="https://fxview.com/static/fxview/pdf/legal-document/Risk-Disclosure-And-Warnings-Notice.pdf" target="_blank">{{$t('riskDisclaimer')}}</a> 
            </div>
              
        </div>-->
    </section>
</template>

<script>
    const crypto = require('crypto');
    import * as types from '@/types'
    import { mapActions } from 'vuex'
	import { rmJson } from '../../../../static/fxView/js/rm_json.js'
    // import language from '../shared/language'
    import { fxViewMixins } from '@/plugins/fxView'
    import VueRecaptcha from 'vue-recaptcha';
    export default {
        name: 'Register',
        mixins: [fxViewMixins],
        data() {
            return {
                residence_country: [],
                country: "",
                current_language: navigator.language.split('-')[0],
                insertId : '-1',
                username : '',
                email :'',
                fname: '',
                lanme: '',
                admin_id :'0',
				rm_id : '',
                admin_idList :[],
                password : '',
                mobile_number :'',
                otp : '',
                error_msg_password : '',
                submitted : false,
                submittedOtp : false,
                inputtype:'password',
                inputtype1: 'password',
                showpassword: false,
                showpassword1: false,
                iconType : 'eye-off',
                userCountry : 'N/A',
                iconType1 : 'eye-off',
                userCountry : 'IN',
                pageLoader : false,
                response_msg : '',
                msg_type : '',
                passwordErr : false,
                numberValid: true,
                numberWithCountry:'',
                captchaVerified: false,
                captchaToken: '',
                captachErr: false,
                IBREFERLINK: '',
                privacyPolicyLink: "https://fxview.com/global/privacy-policy",
                country : "",				
				showRm : false,
				showRmTab : true,
				searchRm : '',
				rmId : '',
				searchResult : '',
				//rmJson : [ ]
            }
        },
        components: {
            // appLanguage: language,
            VueRecaptcha
        },
        methods:{
            tabActiveFun(getData) {
                this.tabActive = getData;
            },
            getCountryCode() {
                let country = "";
                if (this.country) {
                    country = this.country;
                } else if (this.userCountry !== "N/A") {
                    country = this.userCountry;
                }
                return country;
            },
            validateEmail(){
                const validDomain = ['.com','.org','.net','.edu'];
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if(!emailPattern.test(this.email)){
                    this.error = 'Invalid email format.';
                    return;
                }
                const domain = this.email.substring(this.email.lastIndexOf('.'));
                if(!validDomain.includes(domain)){
                    this.error = `Invalid email domain. Please use one of the following: ${validDomain.join(', ')}.`
                } else {
                    this.error = null;
                }
            },
            checkEmail(){
                const _that = this
                // _that.$validator.validate().then(valid => {
                //     if (!(_that.errors.has('email'))) {
                //         let input_json={
                //             'globalParams' :{
                //                 "email": _that.email,
                //             },
                //             'localParams' :{ "parameter" : _that}
                //         }
                //         this._runGetEmailRef(input_json)
                //     }
                // });
            },
			keymonitorFunc(){
				if(this.searchRm != ''){
					let searchResult1 = rmJson.filter(list => {
						return (`${list.name}`.toLowerCase().startsWith(this.searchRm.toLowerCase()))
					});
					if(searchResult1.length > 0){
						this.searchResult = searchResult1
						return this.searchResult ;
					}else{
						this.searchResult = 'no match found'
						this.rmId = ''
						return this.searchResult ;
					}
				}else{
					this.searchResult = ''
					this.rmId = ''
					return  this.searchResult ; 
				}
			},
            hideFunc(){
                this.response_msg = ''
                this.msg_type =''
            },
            switchVisibility(getData) {
                if(getData == '1'){
                    this.showpassword = !this.showpassword
                    if(this.showpassword){
                        this.inputtype = 'text'
                        this.iconType = 'eye'
                    }else{
                        this.inputtype = 'password'
                        this.iconType = 'eye-off'
                    } 
                }else{
                    this.showpassword1 = !this.showpassword1
                    if(this.showpassword1){
                        this.inputtype1 = 'text'
                        this.iconType1 = 'eye'
                    }else{
                        this.inputtype1 = 'password'
                        this.iconType1 = 'eye-off'
                    } 
                }
            }, 
            ...mapActions({
                _runUserSignUp: types.RUN_USER_SIGNUP,
                _runVerifyLeadOtp: types.RUN_VERIFY_LEAD_OTP,
                // _runGetUserIp: types.RUN_GET_USER_IP,
                //_runGetEmailRef: types.RUN_GET_EMAIL_REFERRAL
            }), 
            onCaptchaVerified: function (recaptchaToken) {
                const self = this;
                this.captchaVerified = true
                this.captchaToken = recaptchaToken
                this.create_lead();
            },
            onCaptchaExpired: function () {
              this.$refs.recaptcha.reset();
            },
            resend(){
                const _that = this
                const mykey = crypto.createCipher('aes-128-cbc', 'F*V(I)e^E#1108@3');
                let hashedstr = mykey.update(this.password, 'utf8', 'hex')
                hashedstr += mykey.final('hex');
                let firstname= _that.username.split(' ')[0]
                let lastname = _that.username.replace(firstname , '').trim();
                let input_json={
                    'globalParams' :{
                        fname : firstname,
                        lname : lastname,
                        email: _that.email,
                        admin_id: _that.admin_id,
                        rm_id : _that.rm_id,
                        mobile: _that.numberWithCountry,
                        password : hashedstr,
                        country : _that.country,
                        captchaToken:this.captchaToken,
                        IBREFERLINK:_that.IBREFERLINK
                    },
                    'localParams' :{ "parameter" : this , 'page' : 'resend'}
                }
				if(_that.$cookies.get('IBREFERLINK')){
					input_json.globalParams.IBREFERLINK =this.$cookies.get('IBREFERLINK')
				}else if(_that.$cookies.get('refLink') && _that.$cookies.get('refRm')){
                    let refLink = window.atob(_that.$cookies.get('refLink').toString()) ; 
                    let refRm = window.atob(_that.$cookies.get('refRm').toString()) ; 
                    let join = window.btoa(refLink+"||"+refRm)
                    _that.rm_id = (refLink != undefined)? refLink : '0' //ib_id
                    _that.admin_id = (refRm != undefined)? refRm : '0' //rm_id
                    _that.$cookies.set('IBREFERLINK',join, "4y", null, _that.$env_var.cookieSaveUrl);
                    
                    input_json.globalParams.IBREFERLINK =_that.$cookies.get('IBREFERLINK')
                    input_json.globalParams.rm_id = _that.rm_id
                    input_json.globalParams.admin_id = _that.admin_id
                }
                this._runUserSignUp(input_json)
            },
            updatedText(e) {
                this.numberWithCountry = '+' + e.countryCallingCode + ' ' + e.nationalNumber;
                this.numberValid = e.isValid;
            },
            create_new_lead() {
                const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        const _that = this;
                        _that.$refs.recaptcha.execute();
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
            create_lead(){
                const _that = this
                const mykey = crypto.createCipher('aes-128-cbc', 'F*V(I)e^E#1108@3');
                let hashedstr = mykey.update(_that.password, 'utf8', 'hex')
                hashedstr += mykey.final('hex');
                let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])\S{6,24}$/
                if(!regex.test(_that.password)) {
                    _that.passwordErr = true
                    _that.submitted = false;
                }
                else if(!(this.captchaVerified)){
                    _that.captachErr = true
                    _that.submitted = false;
                }
                else{
                    _that.passwordErr = false
                    _that.submitted = false;
                    let firstname= _that.username.split(' ')[0]
                    let lastname = _that.username.replace(firstname , '').trim();
                    let input_json={
                        globalParams :{
                            fname : firstname,
                            lname : lastname,
                            email: _that.email,
                            admin_id: _that.admin_id,
                            rm_id : _that.rm_id,
                            mobile: _that.numberWithCountry,
                            password : hashedstr,
                            country : _that.country,
                            captchaToken:this.captchaToken,
                            IBREFERLINK:_that.IBREFERLINK
                        },
                        localParams :{ "parameter" : _that }
                    }
                    if(_that.$cookies.get('IBREFERLINK')){
                        input_json.globalParams.IBREFERLINK =_that.$cookies.get('IBREFERLINK')
                    }else if(_that.$cookies.get('refLink') && _that.$cookies.get('refRm')){
                        let refLink = window.atob(_that.$cookies.get('refLink').toString()) ; 
                        let refRm = window.atob(_that.$cookies.get('refRm').toString()) ; 
                        let join = window.btoa(refLink+"||"+refRm)
                        _that.rm_id = (refLink != undefined)? refLink : '0' //ib_id
                        _that.admin_id = (refRm != undefined)? refRm : '0' //rm_id
                        _that.$cookies.set('IBREFERLINK',join, "4y", null, _that.$env_var.cookieSaveUrl);
                        
                        input_json.globalParams.IBREFERLINK =_that.$cookies.get('IBREFERLINK')
                        input_json.globalParams.rm_id = _that.rm_id
                        input_json.globalParams.admin_id = _that.admin_id
                    }
                    _that._runUserSignUp(input_json)
                    _that.$refs.recaptcha.reset();
                }
            },
            verify_lead(){
                const _that = this
                _that.submittedOtp = true;

                const mykey = crypto.createCipher('aes-128-cbc', 'F*V(I)e^E#1108@3');
                let hashedstr = mykey.update(_that.password, 'utf8', 'hex')
                hashedstr += mykey.final('hex');
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                browser_language: _that.current_language,
                                email: _that.email,
                                mobile: _that.numberWithCountry,
                                password : hashedstr,
                                OTP: _that.otp,
                                ID: _that.insertId,
                                IBREFERLINK:_that.IBREFERLINK
                            },
                            'localParams' :{ "parameter" : _that }
                        }
						if(_that.$cookies.get('IBREFERLINK')){
							input_json.globalParams.IBREFERLINK =_that.$cookies.get('IBREFERLINK')
						}else if(_that.$cookies.get('refLink') && _that.$cookies.get('refRm')){
                            let refLink = window.atob(_that.$cookies.get('refLink').toString()) ; 
                            let refRm = window.atob(_that.$cookies.get('refRm').toString()) ; 
                            let join = window.btoa(refLink+"||"+refRm)
                            _that.rm_id = (refLink != undefined)? refLink : '0' //ib_id
                            _that.admin_id = (refRm != undefined)? refRm : '0' //rm_id
                            _that.$cookies.set('IBREFERLINK',join, "4y", null, _that.$env_var.cookieSaveUrl);
                            input_json.globalParams.IBREFERLINK =_that.$cookies.get('IBREFERLINK')
                        }

                        _that._runVerifyLeadOtp(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            }
        },
        created(){
            const _that = this
			if(this.$route.query.refLink){
				this.showRmTab = false
				let decrpyLinRm = window.atob(this.$route.query.refLink.toString()) ; 
				let decrpyLinRm1 = decrpyLinRm.split('||')
				this.rm_id = (decrpyLinRm1[0] != undefined)? decrpyLinRm1[0] : '0' //ib_id
				this.admin_id = (decrpyLinRm1[1] != undefined)? decrpyLinRm1[1] : '0' //rm_id
				this.$cookies.set('IBREFERLINK',this.$route.query.refLink, "4y", null, this.$env_var.cookieSaveUrl);
            }else if(this.$cookies.get('refLink') && this.$cookies.get('refRm')){
                let refLink = window.atob(this.$cookies.get('refLink').toString()) ; 
                let refRm = window.atob(this.$cookies.get('refRm').toString()) ; 
                let join = window.btoa(refLink+"||"+refRm)
                this.rm_id = (refLink != undefined)? refLink : '0' //ib_id
                this.admin_id = (refRm != undefined)? refRm : '0' //rm_id
                this.$cookies.set('IBREFERLINK',join, "4y", null, this.$env_var.cookieSaveUrl);
            }
            this._runGetCountriesList({'globalParams' : {} ,'localParams' : {'parameter' : this}})
            if("verify" in this.$route.query){
                const encyptKey =  this.$route.query['verify']
                let mykey = crypto.createDecipher('aes-128-cbc', 'F*V(I)e^E#1108@3'); 
                let mystr = mykey.update(encyptKey, 'hex', 'utf8')
                mystr += mykey.final('utf8');
                let infoArray = mystr.split("^")
                if(this.$cookies.isKey("IBREFERLINK")){
                    this.IBREFERLINK = this.$cookies.get("IBREFERLINK");
                }
                if(_that.IBREFERLINK == ''){
                    _that.IBREFERLINK = infoArray[5]
                }
                let input_json={
                    'globalParams' :{
                        "email": infoArray[3],
                        "mobile": infoArray[4],
                        "password" : infoArray[2],
                        "OTP": infoArray[0],
                        "ID": infoArray[1],
                        "IBREFERLINK":_that.IBREFERLINK
                    },
                    'localParams' :{ "parameter" : _that }
                }
                //console.log('incripted req data =>',input_json)
                _that._runVerifyLeadOtp(input_json)
                // console.log(mystr); //abc
            }  
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/users/register_ib.vue